import { render, staticRenderFns } from "./Lwlist.vue?vue&type=template&id=0ed0977a&scoped=true"
import script from "./Lwlist.vue?vue&type=script&lang=js"
export * from "./Lwlist.vue?vue&type=script&lang=js"
import style0 from "./Lwlist.vue?vue&type=style&index=0&id=0ed0977a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0977a",
  null
  
)

export default component.exports